export default __webpack_public_path__ + "static/media/before-after@2x.e81d683f.png";